// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/caixa/services/caixaService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  CaixaOpcao,
  CaixaLancamento,
  SaldoCaixa,
  CriarLancamentoCaixaRequest,
  ReforcoSangriaRequest,
  CaixaExtrato,
  ConciliacaoResultado,
  ConciliarLoteRequest,
} from '../types';

const BASE = '/api/caixa';

export const caixaService = {
  async listarCaixas(): Promise<CaixaOpcao[]> {
    const { data } = await apiClient.get<CaixaOpcao[]>(`${BASE}/caixas`);
    return data;
  },

  async getSaldo(caixaId: number): Promise<SaldoCaixa> {
    const { data } = await apiClient.get<SaldoCaixa>(`${BASE}/saldo/${caixaId}`);
    return data;
  },

  async getAberto(caixaId: number): Promise<CaixaLancamento | null> {
    try {
      const { data } = await apiClient.get<CaixaLancamento>(`${BASE}/aberto/${caixaId}`);
      return data;
    } catch {
      return null;
    }
  },

  async getPorPeriodo(inicio: string, fim: string): Promise<CaixaLancamento[]> {
    const { data } = await apiClient.get<CaixaLancamento[]>(`${BASE}/periodo`, {
      params: { inicio, fim },
    });
    return data;
  },

  async getById(id: number): Promise<CaixaLancamento> {
    const { data } = await apiClient.get<CaixaLancamento>(`${BASE}/${id}`);
    return data;
  },

  async registrar(request: CriarLancamentoCaixaRequest): Promise<CaixaLancamento> {
    const { data } = await apiClient.post<CaixaLancamento>(BASE, request);
    return data;
  },

  async getExtrato(caixaId: number, inicio?: string, fim?: string): Promise<CaixaExtrato> {
    const { data } = await apiClient.get<CaixaExtrato>(`${BASE}/${caixaId}/extrato`, {
      params: { inicio, fim },
    });
    return data;
  },

  async reforco(caixaId: number, request: ReforcoSangriaRequest): Promise<CaixaLancamento> {
    const { data } = await apiClient.post<CaixaLancamento>(`${BASE}/${caixaId}/reforco`, request);
    return data;
  },

  async sangria(caixaId: number, request: ReforcoSangriaRequest): Promise<CaixaLancamento> {
    const { data } = await apiClient.post<CaixaLancamento>(`${BASE}/${caixaId}/sangria`, request);
    return data;
  },

  async conciliar(id: number): Promise<ConciliacaoResultado> {
    const { data } = await apiClient.put<ConciliacaoResultado>(`${BASE}/${id}/conciliar`);
    return data;
  },

  async conciliarLote(request: ConciliarLoteRequest): Promise<ConciliacaoResultado[]> {
    const { data } = await apiClient.post<ConciliacaoResultado[]>(`${BASE}/conciliar-lote`, request);
    return data;
  },
};
